import apiClient from "../api/client";

import { teams } from "../constants/actionTypes";

export const actions = {
  refreshOwnerTeam() {
    return dispatch =>
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/api-v2/teams2/owner"
      })
        .then(response => {
          dispatch({
            type: teams.REFRESH_OWNER_TEAM,
            payload: {
              owner: response?.data?.data?.items || [],
              limits: response?.data?.data?.limits || {}
            }
          });
        })
        .catch(error => {
          dispatch({
            type: teams.REFRESH_OWNER_TEAM_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
  },

  refreshMemberTeam() {
    return dispatch =>
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/api-v2/teams2/member"
      })
        .then(response => {
          dispatch({
            type: teams.REFRESH_MEMBER_TEAM,
            payload: response?.data?.data || []
          });
        })
        .catch(error => {
          dispatch({
            type: teams.REFRESH_MEMBER_TEAM_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
  },

  getTeams() {
    return dispatch => {
      dispatch(this.setLoading("page", true));

      Promise.all([
        apiClient({
          method: "get",
          responseType: "json",
          url: "/members/api-v2/teams2/owner"
        }),
        apiClient({
          method: "get",
          responseType: "json",
          url: "/members/api-v2/teams2/member"
        }),
        apiClient({
          method: "get",
          responseType: "json",
          url: "/members/api-v2/teams2/limits"
        }),
        apiClient({
          method: "get",
          responseType: "json",
          url: "/members/api-v2/teams2/roles"
        })
      ])
        .then(([owner, member, limits, roles]) => {
          dispatch({
            type: teams.GET_TEAMS,
            payload: {
              owner: owner?.data?.data?.items || [],
              member: member?.data?.data || [],
              limits: owner?.data?.data?.limits || limits?.data?.data || {},
              roles: roles?.data?.data || []
            }
          });
        })
        .catch(error => {
          dispatch({
            type: teams.GET_TEAMS_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },
  getTeamsMember() {
    return dispatch => {
      dispatch(this.setLoading("page", true));

      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/api-v2/teams2/member"
      })
        .then(response => {
          dispatch({
            type: teams.GET_TEAMS_MEMBER,
            payload: response?.data?.data || []
          });
        })
        .catch(error => {
          dispatch({
            type: teams.GET_TEAMS_MEMBER_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },
  removeAccess(data) {
    return dispatch => {
      dispatch(this.setLoading("remove", true));

      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/api-v2/teams2/remove",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        data
      })
        .then(() => {
          dispatch({
            type: teams.REMOVE_ACCESS,
            payload: data.team_member_id
          });
          dispatch(this.refreshMemberTeam());
          dispatch(this.refreshOwnerTeam());
        })
        .catch(error => {
          dispatch({
            type: teams.REMOVE_ACCESS_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },
  rejectAccess(data) {
    return dispatch => {
      dispatch(this.setLoading("reject", true));

      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/api-v2/teams2/reject",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        data
      })
        .then(() => {
          dispatch({
            type: teams.REJECT_ACCESS,
            payload: data.team_member_id
          });
        })
        .catch(error => {
          dispatch({
            type: teams.REJECT_ACCESS_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },
  acceptAccess(data) {
    return dispatch => {
      dispatch(this.setLoading("accept", true));

      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/api-v2/teams2/accept",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        data
      })
        .then(response => {
          dispatch({
            type: teams.ACCEPT_ACCESS,
            payload: response,
            meta: { team_member_id: data.team_member_id }
          });

          dispatch(this.getTeamsMember());
        })
        .catch(error => {
          dispatch({
            type: teams.ACCEPT_ACCESS_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },
  inviteAccess({ email, name, role, access_duration, expiration_date }, { resend = false } = {}) {
    return dispatch => {
      dispatch(this.setLoading("invite", true));

      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/api-v2/teams2/invite",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        data: { email, name, role, access_duration, expiration_date }
      })
        .then(response => {
          dispatch({
            type: teams.INVITE_ACCESS,
            payload: response,
            meta: { email, resend }
          });

          dispatch(this.refreshOwnerTeam());
        })
        .catch(error => {
          dispatch({
            type: teams.INVITE_ACCESS_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },

  updateAccess({ team_member_id, role, access_duration, expiration_date }) {
    return dispatch => {
      dispatch(this.setLoading("update", true));

      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/api-v2/teams2/update",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        data: { team_member_id, role, access_duration, expiration_date }
      })
        .then(response => {
          dispatch({
            type: teams.UPDATE_ACCESS,
            payload: response,
            meta: { team_member_id }
          });

          dispatch(this.refreshOwnerTeam());
        })
        .catch(error => {
          dispatch({
            type: teams.UPDATE_ACCESS_FAIL,
            payload: error.response?.data?.error || error.message || "Unexpected error"
          });
        });
    };
  },

  toggleModal(modal, isActive) {
    return {
      type: teams.TOGGLE_MODAL,
      payload: {
        modal,
        isActive
      }
    };
  },

  handleActiveAccess(access) {
    return {
      type: teams.ACTIVE_ACCESS,
      payload: access
    };
  },

  clearAllModals() {
    return {
      type: teams.CLEAR_ALL_MODALS
    };
  },

  clearToast() {
    return {
      type: teams.CLEAR_TOAST
    };
  },

  clearError() {
    return {
      type: teams.CLEAR_ERROR
    };
  },

  setCurrentTeam(team) {
    return {
      type: teams.SET_TEAM,
      payload: team
    };
  },

  setLoading(name, isLoading) {
    return {
      type: teams.SET_LOADING,
      payload: { name, isLoading }
    };
  }
};
